import Model from "./Model";

export default class Milestone extends Model{

	title!: string;
	description!: string;
  date!: Date;
  initiativeId!: string;
  completed!: string|boolean;
}
